const pythonDateToString = (date: string): string => {
  if (!date) return ''

  let pices = date.split('.')
  const year = pices[2]

  let month_str = pices[1]
  const month = parseInt(month_str)

  let day_str = pices[0]
  const day = parseInt(day_str)

  if (month < 10) month_str = '0' + month
  if (day < 10) day_str = '0' + day

  return year + '-' + month_str + '-' + day_str
}

const pythonDateTimeToString = (date: string): string => {
  if (!date) return ''

  let pices = date.split(' ')
  pices = [...pices[0].split('.'), ...pices[1].split(':')]
  const year = pices[2]

  let month_str = pices[1]
  const month = parseInt(month_str)

  let day_str = pices[0]
  const day = parseInt(day_str)

  let hour_str = pices[3]
  const hour = parseInt(hour_str)

  let minute_str = pices[4]
  const minute = parseInt(minute_str)

  if (month < 10) month_str = '0' + month
  if (day < 10) day_str = '0' + day
  if (hour < 10) hour_str = '0' + hour
  if (minute < 10) minute_str = '0' + minute

  return year + '-' + month_str + '-' + day_str + 'T' + hour_str + ':' + minute_str
}

const jsDateToString = (date: Date): string => {
  const year = date.getFullYear()
  let month = date.getMonth() + 1
  let day = date.getDate()

  let month_str = month.toString()
  let day_str = day.toString()

  if (month < 10) month_str = '0' + month
  if (day < 10) day_str = '0' + day

  return year + '-' + month_str + '-' + day_str
}

const jsDateTimeToString = (date: Date): string => {
  let hour = date.getHours()
  let minute = date.getMinutes()

  let hour_str = hour.toString()
  let minute_str = hour.toString()

  if (hour < 10) hour_str = '0' + hour
  if (minute < 10) minute_str = '0' + minute

  return jsDateToString(date) + 'T' + hour_str + ':' + minute_str
}

export { pythonDateToString, pythonDateTimeToString, jsDateToString, jsDateTimeToString }
